var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"loading":_vm.downloadLoading,"icon":"el-icon-download","size":_vm.$store.state.element.elBtnSize},on:{"click":_vm.handleDownload}},[_vm._v("\n    "+_vm._s(_vm.btnText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }